import React from 'react';
import { Grid } from '@material-ui/core';

const WorkMacOS = (props) => {
    const { classes, translations } = props;
    const icon = (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fill="#7485FF"
                d="M30.8763 28.8522L27.0931 31.0435L24.3471 25.9913L17.94 14.1217V36.4609L15.4992 37.9217L12.7533 36.3391V14.5478L6.65122 26.113L3.96633 31.2261L0 28.913V26.7217L6.10204 14.7913V14.8522L9.82429 7.48696L13.6076 0.0608696H17.2688L24.4692 13.9391L24.042 0H29.839L30.5712 22.4L30.8763 28.8522Z"
            />
            <path fill="#7485FF" d="M6.89439 0.0605469L6.52827 7.30403L0.243164 19.5388L1.09745 0.0605469H6.89439Z" />
        </svg>
    );

    return (
        <>
            <Grid item ms={12} lg={6}>
                <h2>
                    {icon} Work (macOS T2 & M1/M2){' '}
                    {classes.latestVersionSpan && (
                        <span className={classes.latestVersionSpan}>
                            - {translations['latest_version'] || 'Latest Version'}
                        </span>
                    )}
                </h2>
                <p>
                    {translations['work_macOS_download_page'] ||
                        'Complete tool for secure erasure and diagnostics of Apple computers with T2 chip and Apple Silicon computers with M1/M2 chip.'}
                </p>
            </Grid>
        </>
    );
};

export default WorkMacOS;
